// Shared display formatting only. No conversion or currency aggregation.
export const formatMoney = (amount, currency = 'eur') => {
  const code = String(currency || 'eur').toUpperCase();
  const value = Number(amount || 0);
  try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: code }).format(value); }
  catch { return `${value.toFixed(2)} ${code}`; }
};